import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-info-tooltip',
  templateUrl: './report-info-tooltip.component.html',
  styleUrls: ['./report-info-tooltip.component.scss']
})
export class ReportInfoTooltipComponent implements OnInit {
  @Input() public text: string;

  ngOnInit(): void {
  }
}
